// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "5e525dc29bd2bea10ffc" + "/js/" + chunkId + ".js";
};